import { h, defineAsyncComponent } from 'vue'
import type { PaywallRoute } from '@/@types/router-types'

const PaywallView = defineAsyncComponent(() => import('@/modules/Paywall/PaywallView.vue'))

type PaywallInstance = {
	name: PaywallRoute
	config: () => Promise<unknown>
}

type PaywallRedirect = {
	name: `plan-email-${string}`
	redirect: { name: PaywallRoute }
}

export const paywallInstances: PaywallInstance[] = [
	{
		name: 'plan-email',
		config: () => import('@/modules/Paywall/instances/crm/email'),
	},
	{
		name: 'plan-email-assessment',
		config: () => import('@/modules/Paywall/instances/crm/email-assessment'),
	},
	{
		name: 'plan-email-female',
		config: () => import('@/modules/Paywall/instances/crm/email-female'),
	},
	{
		name: 'plan-email-pilates',
		config: () => import('@/modules/Paywall/instances/crm/email-pilates'),
	},
	{
		name: 'plan-email-one-click-purchase',
		config: () => import('@/modules/Paywall/instances/crm/email-one-click-purchase'),
	},
	{
		name: 'plan-email-one-click-male', // Don't rename
		config: () => import('@/modules/Paywall/instances/crm/one-click/email-one-click-m'),
	},
	{
		name: 'plan-email-one-click-female', // Don't rename
		config: () => import('@/modules/Paywall/instances/crm/one-click/email-one-click-f'),
	},
	{
		name: 'plan-in-app', // Don't rename
		config: () => import('@/modules/Paywall/instances/in-app'),
	},
	{
		name: 'plan-mobile-paywall-v2', // New Mobile Paywall v2 (US) web checkout — DEV-33404
		config: () => import('@/modules/Paywall/instances/mobile-paywall-v2'),
	},
	{
		name: 'plan-main',
		config: () => import('@/modules/Paywall/instances/areas/fasting/main'),
	},
	{
		name: 'plan-m',
		config: () => import('@/modules/Paywall/instances/areas/fasting/m'),
	},
	{
		name: 'plan-m-eu',
		config: () => import('@/modules/Paywall/instances/areas/fasting/m-eu'),
	},
	{
		name: 'plan-f',
		config: () => import('@/modules/Paywall/instances/areas/fasting/f'),
	},
	{
		name: 'plan-hashimoto-diet-f',
		config: () => import('@/modules/Paywall/instances/areas/diets/hashimoto-diet-f'),
	},
	{
		name: 'plan-m-pr',
		config: () => import('@/modules/Paywall/instances/areas/fasting/m-pr'),
	},
	{
		name: 'plan-f-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/f-al'),
	},
	{
		name: 'plan-water-fasting-f-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/water-fasting-f-al'),
	},
	{
		name: 'plan-f-eu',
		config: () => import('@/modules/Paywall/instances/areas/fasting/f-eu'),
	},
	{
		name: 'plan-f-pr',
		config: () => import('@/modules/Paywall/instances/areas/fasting/f-pr'),
	},
	{
		name: 'plan-activity-f',
		config: () => import('@/modules/Paywall/instances/areas/activity/activity-f'),
	},
	{
		name: 'plan-activity-f-eu',
		config: () => import('@/modules/Paywall/instances/areas/activity/activity-f-eu'),
	},
	{
		name: 'plan-activity-m',
		config: () => import('@/modules/Paywall/instances/areas/activity/activity-m'),
	},
	{
		name: 'plan-activity-m-eu',
		config: () => import('@/modules/Paywall/instances/areas/activity/activity-m-eu'),
	},
	{
		name: 'plan-pilates-f',
		config: () => import('@/modules/Paywall/instances/areas/pilates/pilates-f'),
	},
	{
		name: 'plan-pilates-f-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/pilates-f-al'),
	},
	{
		name: 'plan-yoga-f',
		config: () => import('@/modules/Paywall/instances/areas/yoga/yoga-f'),
	},
	{
		name: 'plan-yoga-f-eu',
		config: () => import('@/modules/Paywall/instances/areas/yoga/yoga-f-eu'),
	},
	{
		name: 'plan-chair-workouts-m',
		config: () => import('@/modules/Paywall/instances/areas/yoga/chair-workouts-m'),
	},
	{
		name: 'plan-chair-workouts-m-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/chair-workouts-m-al'),
	},
	{
		name: 'plan-chair-tai-chi-m',
		config: () => import('@/modules/Paywall/instances/areas/tai-chi/chair-tai-chi-m'),
	},
	{
		name: 'plan-chair-tai-chi-m-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/chair-tai-chi-m-al'),
	},
	{
		name: 'plan-walking-f',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-f'),
	},
	{
		name: 'plan-walking-outdoor-f',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-outdoor-f'),
	},
	{
		name: 'plan-walking-outdoor-f-us',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-outdoor-f-us'),
	},
	{
		name: 'plan-walking-outdoor-f-eu',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-outdoor-f-eu'),
	},
	{
		name: 'plan-printable-walking-f',
		config: () => import('@/modules/Paywall/instances/areas/walking/printable-walking-f'),
	},
	{
		name: 'plan-walking-f-us',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-f-us'),
	},
	{
		name: 'plan-walking-f-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/walking-f-al'),
	},
	{
		name: 'plan-walking-f-eu',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-f-eu'),
	},
	{
		name: 'plan-tai-chi-walking-f-v2',
		config: () => import('@/modules/Paywall/instances/areas/tai-chi/tai-chi-walking-f-v2'),
	},
	{
		name: 'plan-crm-tai-chi-walking-f-v2',
		config: () => import('@/modules/Paywall/instances/crm/crm-tai-chi-walking-f-v2'),
	},
	{
		name: 'plan-tai-chi-walking-f-v2-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/tai-chi-walking-f-v2-al'),
	},
	{
		name: 'plan-tai-chi-move-f',
		config: () => import('@/modules/Paywall/instances/areas/move/tai-chi-move-f'),
	},
	{
		name: 'plan-tai-chi-walking-f-pr',
		config: () => import('@/modules/Paywall/instances/areas/tai-chi/tai-chi-walking-f-pr'),
	},
	{
		name: 'plan-walking-m',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-m'),
	},
	{
		name: 'plan-tai-chi-walking-m-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/tai-chi-walking-m-al'),
	},
	{
		name: 'plan-walking-m-us',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-m-us'),
	},
	{
		name: 'plan-walking-m-eu',
		config: () => import('@/modules/Paywall/instances/areas/walking/walking-m-eu'),
	},
	{
		name: 'plan-tai-chi-f',
		config: () => import('@/modules/Paywall/instances/areas/tai-chi/tai-chi-f'),
	},
	{
		name: 'plan-tai-chi-yoga-m',
		config: () => import('@/modules/Paywall/instances/areas/tai-chi/tai-chi-yoga-m'),
	},
	{
		name: 'plan-tai-chi-yoga-m-al',
		config: () => import('@/modules/Paywall/instances/areas/applovin/tai-chi-yoga-m-al'),
	},
	{
		name: 'plan-tai-chi-yoga-m-pr',
		config: () => import('@/modules/Paywall/instances/areas/tai-chi/tai-chi-yoga-m-pr'),
	},
	{
		name: 'plan-calisthenics-m',
		config: () => import('@/modules/Paywall/instances/areas/calisthenics/calisthenics-m'),
	},
	{
		name: 'plan-military-calisthenics-m',
		config: () => import('@/modules/Paywall/instances/areas/calisthenics/military-calisthenics-m'),
	},
	{
		name: 'plan-military-calisthenics-m-pr',
		config: () => import('@/modules/Paywall/instances/areas/calisthenics/military-calisthenics-m-pr'),
	},
	{
		name: 'plan-military-calisthenics-sh-m',
		config: () =>
			import(
				/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/areas/calisthenics/military-calisthenics-sh-m'
			),
	},
	{
		name: 'plan-military-calisthenics-f',
		config: () => import('@/modules/Paywall/instances/areas/calisthenics/military-calisthenics-f'),
	},
	{
		name: 'plan-military-calisthenics-f-pr',
		config: () => import('@/modules/Paywall/instances/areas/calisthenics/military-calisthenics-f-pr'),
	},
	{
		name: 'plan-calisthenics-f',
		config: () => import('@/modules/Paywall/instances/areas/calisthenics/calisthenics-f'),
	},
	{
		name: 'plan-carnivore-f',
		config: () => import('@/modules/Paywall/instances/areas/diets/carnivore-f'),
	},
	{
		name: 'plan-carnivore-m',
		config: () => import('@/modules/Paywall/instances/areas/diets/carnivore-m'),
	},
	{
		name: 'plan-japanese-diet-f',
		config: () => import('@/modules/Paywall/instances/areas/diets/japanese-diet-f'),
	},
	{
		name: 'plan-japanese-diet-m',
		config: () => import('@/modules/Paywall/instances/areas/diets/japanese-diet-m'),
	},
	{
		name: 'plan-korean-glow-diet-f',
		config: () => import('@/modules/Paywall/instances/areas/diets/korean-glow-diet-f'),
	},
]

const paywallRedirects: PaywallRedirect[] = [
	{ name: 'plan-email-activity', redirect: { name: 'plan-activity-f' } },
	{ name: 'plan-email-activity-male', redirect: { name: 'plan-activity-m' } },
	{ name: 'plan-email-pilates-commitment', redirect: { name: 'plan-pilates-f' } },
	{ name: 'plan-email-yoga', redirect: { name: 'plan-yoga-f' } },
	{ name: 'plan-email-chair-workouts-m', redirect: { name: 'plan-chair-workouts-m' } },
	{ name: 'plan-email-chair-tai-chi-m', redirect: { name: 'plan-chair-tai-chi-m' } },
	{ name: 'plan-email-walking', redirect: { name: 'plan-walking-f' } },
	{ name: 'plan-email-walking-male', redirect: { name: 'plan-walking-m' } },
	{ name: 'plan-email-calisthenics-male', redirect: { name: 'plan-calisthenics-m' } },
	{ name: 'plan-email-calisthenics-female', redirect: { name: 'plan-calisthenics-f' } },
	{ name: 'plan-email-tai-chi-yoga-male', redirect: { name: 'plan-tai-chi-yoga-m' } },
]

const paywallInstanceRoutes = paywallInstances.map((instance) => {
	const id = instance.name.replace('plan-', '')
	return {
		path: `/plan/${id}`,
		name: instance.name,
		component: {
			render: () =>
				h(PaywallView, {
					key: id,
					id,
					config: instance.config,
				}),
		},
		meta: {
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'OnboardingCreatedProgramScreen',
				},
			},
		},
	}
})

const paywallRedirectRoutes = paywallRedirects.map((item) => {
	const id = item.name.replace('plan-', '')
	return {
		path: `/plan/${id}`,
		name: item.name,
		redirect: item.redirect,
	}
})

const paywallRoutesList = [...paywallInstanceRoutes, ...paywallRedirectRoutes]

export default paywallRoutesList
